/*
     Title:Sewing Inspection API
     Description:Sewing Inspection API
     Author: Iqbal Hossain
     Date: 29-January-2022
     Modified: 29-January-2022
*/

export const SEWING_INSPECTION_API = {
  root: '/api/sewing-inspection',
  fetch_all: 'api/sewing-inspection/fetch-all',
  fetch_by_query: `/api/sewing-inspection/fetch-by-query`,
  fetch_by_id: `/api/sewing-inspection/fetch-by-id`
};
